import { Link } from "react-router-dom";
import { TranslationService } from "../../../../services/TranslationService";
import { ButtonTooltipIcon } from "../../../shared/components/ButtonTooltipIcon";
import FloatingPanelService from "../../../shared/FloatingPanel";
import NewScheduledTaskForm from "./add/NewScheduledTaskForm";
import { useContext } from "react";
import { ScheduledTaskTableContextValues } from "./ScheduledTaskTableProvider";
import TableContext from "../../TableContext";
import CompanyService from "../../../../services/CompanyService";

const FilterScheduledTask = () => {
  const tableContext = useContext(TableContext);
  const { reload, response } = tableContext as ScheduledTaskTableContextValues;
  const { translate, currentLanguage } = TranslationService;
  const showNewTaskPanel = () => {
    FloatingPanelService.showPanel({
      children: <NewScheduledTaskForm onNewTask={reload} />,
      title: translate.NewScheduledTask,
      width: 700,
      height: 650
    });
  };

  return (
    <>
      <div className="genericHeader gap-12">
        <div className="col-auto ps-0">
          <div className="actionButtonsHeader ">
            <div className="d-flex align-items-center">
              {CompanyService.canDo("newtask") && (
                <ButtonTooltipIcon
                  title={`${translate.NewScheduledTask}`}
                  icon="fa-light fa-plus"
                  onClick={showNewTaskPanel}
                  isLink={false}
                />
              )}
            </div>
            <div className="d-flex align-items-center big-dropdown">
              <Link
                className="btn btn-secondary"
                to={`/${currentLanguage}/task`}
              >
                {translate.GoBackTask}
              </Link>
            </div>
            <div className="d-flex align-items-center">
              <label>
                {translate.ScheduledTasks} ({response?.itemCount ?? 0})
              </label>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterScheduledTask;
